import { getBaseUrl } from "api/client/core/request";
import axios from "axios";

const REFRESH_TOKEN_URL = "/v1/refresh_token";

export function setupAxios() {
    // Request interceptor to add access_token to headers
    axios.interceptors.request.use(
        (config) => {
            const accessToken = localStorage.getItem('access_token');
            if (accessToken) {
                config.headers['Authorization'] = `Bearer ${accessToken}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Response interceptor to handle 401 and 403 status codes
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;

            // Check if the error status is 401 or 403 and if the request hasn't been retried yet
            // Also, ensure the request URL is not the refresh token endpoint
            if (
                (error.response && (error.response.status === 401 || error.response.status === 403)) &&
                !originalRequest._retry &&
                !originalRequest.url.includes(REFRESH_TOKEN_URL)
            ) {
                originalRequest._retry = true;

                try {
                    // Retrieve refresh_token from localStorage
                    const refreshToken = localStorage.getItem('refresh_token');

                    if (!refreshToken) {
                        // Redirect to login or handle accordingly
                        window.location.href = '/sign-in';
                        return;
                    }

                    // Make refresh token request
                    const response = await axios.post(`${getBaseUrl()}${REFRESH_TOKEN_URL}?refresh_token=${refreshToken}`, {
                        refresh_token: refreshToken,
                    }).catch((refreshError) => {
                        console.error(refreshError);
                    })

                    if (response?.status === 200) {
                        // Save new tokens in localStorage
                        localStorage.setItem('access_token', response.data.access_token);
                        localStorage.setItem('refresh_token', response.data.refresh_token);

                        // Update original request with new access_token
                        originalRequest.headers['Authorization'] = `Bearer ${response.data.access_token}`;

                        // Retry the original request
                        return axios(originalRequest);
                    } else {
                        // Redirect to login
                        window.location.href = '/sign-in';
                    }
                } catch (refreshError) {
                    // Handle refresh token request errors
                    console.error(refreshError);
                }
            }

            return Promise.reject(error);
        }
    );
}

